<template lang="pug">
  .event__price(v-if="isNormalPriceAvailable")
    span(v-if="isNormalPriceAvailable")

      span.event__line-title(v-if="isDiscountPriceAvailable") {{getPriceNormTitle}}:
      | {{priceToString(price.norm)}}

    span(v-if="isDiscountPriceAvailable")

      span.event__line-title {{getPriceDiscTitle}}:
      | {{priceToString(price.disc)}}
</template>

<script>
import priceToString from "@/mixins/price-to-string";
import {mapGetters} from "vuex";

export default {
  mixins: [priceToString],
  props: {
    price: {
      type: Object,
      required: false,
    }
  },
  computed: {
    ...mapGetters('config', ['getPriceNormTitle', 'getPriceDiscTitle']),
    isNormalPriceAvailable() {
      return !!this.price?.norm;
    },
    isDiscountPriceAvailable() {
      return !!this.price?.disc;
    }
  }
}
</script>
